import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import PwaStatus from './components/pwa/PwaStatus';
import { swUpdateStore } from './components/pwa/swUpdateStore';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Convex client inicializálása
const convex = new ConvexReactClient(
  process.env.REACT_APP_CONVEX_URL || 'https://placeholder.convex.cloud'
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConvexProvider client={convex}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <PwaStatus />
          <App />
        </AuthProvider>
      </Router>
    </ConvexProvider>
  </React.StrictMode>
);

// PWA: service worker csak production buildben; új verziónál a PwaStatus jelez
serviceWorkerRegistration.register({
  onUpdate: (registration) => swUpdateStore.setWaiting(registration),
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
